module.exports = __webpack_public_path__ + "img/web_app_interface.5b4703e3.png";